import React from "react"
import { TextField, InputAdornment, TextFieldProps, SxProps } from "@mui/material"
import { SearchTextField } from "./style"
import { IconSearch } from "../../../icons/IconSearch"

type SearchInputProps = {
  placeholder?: string
  fullWidth?: boolean
  inputProps?: TextFieldProps["inputProps"]
  sx?: SxProps

  value?: string
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  onBlur?: () => void
  name?: string
}

export const SearchInput = React.forwardRef<HTMLInputElement, SearchInputProps>(
  (
    {
      placeholder = "Поиск...",
      fullWidth = true,
      inputProps,
      sx,
      value = '',
      onChange,
      onBlur,
      name,
    },
    ref
  ) => {
    return (
      <TextField
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        fullWidth={fullWidth}
        inputProps={inputProps}
        sx={sx}
        inputRef={ref}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <IconSearch />
            </InputAdornment>
          ),
          sx: SearchTextField,
        }}
      />
    )
  }
)
